import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireSession } from '@/app/guards';

/** Everything below requires a session. The resolved `me` is available in route context. */
export const Route = createFileRoute('/_authed')({
  beforeLoad: async ({ context, location }) => ({
    me: await requireSession({ context, location }),
  }),
  component: Outlet,
});
